var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.addressFormVisible > 0 ? _vm.$style.long : _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.submitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm.company && _vm.company.id
          ? _c("div", [_vm._v(" Edit Company ")])
          : _c("div", [_vm._v(" Create New Company ")]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          class: _vm.$style.body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "rb-input",
            { attrs: { "for-id": "accountId", error: _vm.$showError("name") } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Company Name*"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.name,
                    expression: "data.name",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "name",
                  name: "name",
                  "data-vv-as": "Company Name",
                  placeholder: "Company Name",
                  autofocus: "",
                },
                domProps: { value: _vm.data.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data, "name", $event.target.value)
                  },
                },
              }),
            ]
          ),
          _c(
            "div",
            { class: _vm.$style.group },
            [
              _c(
                "rb-input",
                {
                  attrs: {
                    "for-id": "accountId",
                    error: _vm.$showError("industry"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Company Industry*"),
                  ]),
                  _c("rb-select-new", {
                    staticClass: "simple",
                    attrs: {
                      id: "industry",
                      options: _vm.industries,
                      name: "industry",
                      "data-vv-as": "Company Industry",
                      placeholder: "Select...",
                    },
                    model: {
                      value: _vm.data.industry,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "industry", $$v)
                      },
                      expression: "data.industry",
                    },
                  }),
                ],
                1
              ),
              _c(
                "rb-input",
                {
                  attrs: {
                    "for-id": "accountId",
                    error: _vm.$showError("website"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Company Website URL*"),
                  ]),
                  _c("rbv-input-url", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { url: true, required: true },
                        expression: "{url: true, required: true}",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "website",
                      placeholder: "http://yoursiteishere.com",
                      name: "website",
                      "data-vv-as": "Company Website URL",
                    },
                    model: {
                      value: _vm.data.website,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "website", $$v)
                      },
                      expression: "data.website",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.company || !_vm.company.id
            ? [
                _c(
                  "div",
                  { class: _vm.$style.group },
                  [
                    _c(
                      "rb-input",
                      {
                        attrs: {
                          "for-id": "primaryContactFirstName",
                          error: _vm.$showError("primaryContactFirstName"),
                        },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v("Company Contact First Name")]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.primaryContact.firstName,
                              expression: "primaryContact.firstName",
                            },
                          ],
                          staticClass: "rbInput",
                          attrs: {
                            id: "primaryContactFirstName",
                            name: "primaryContactFirstName",
                            placeholder: "Company Contact First Name",
                          },
                          domProps: { value: _vm.primaryContact.firstName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.primaryContact,
                                "firstName",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                    _c(
                      "rb-input",
                      {
                        attrs: {
                          "for-id": "primaryContactLastName",
                          error: _vm.$showError("primaryContactLastName"),
                        },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v("Company Contact Last Name")]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.primaryContact.lastName,
                              expression: "primaryContact.lastName",
                            },
                          ],
                          staticClass: "rbInput",
                          attrs: {
                            id: "primaryContactLastName",
                            name: "primaryContactLastName",
                            placeholder: "Company Contact Last Name",
                          },
                          domProps: { value: _vm.primaryContact.lastName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.primaryContact,
                                "lastName",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { class: _vm.$style.group },
                  [
                    _c(
                      "rb-input",
                      {
                        attrs: {
                          "for-id": "primaryContactEmail",
                          error: _vm.$showError("primaryContactEmail"),
                        },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v("Company Contact Email Address")]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.primaryContact.emailAddress,
                              expression: "primaryContact.emailAddress",
                            },
                          ],
                          staticClass: "rbInput",
                          attrs: {
                            id: "primaryContactEmail",
                            name: "primaryContactEmail",
                            placeholder: "Company Contact Email Address",
                          },
                          domProps: { value: _vm.primaryContact.emailAddress },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.primaryContact,
                                "emailAddress",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                    _c(
                      "rb-input",
                      {
                        attrs: {
                          "for-id": "primaryContactPhone",
                          error: _vm.$showError("primaryContactPhone"),
                        },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v("Company Contact Phone Number")]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.primaryContact.phone,
                              expression: "primaryContact.phone",
                            },
                          ],
                          staticClass: "rbInput",
                          attrs: {
                            id: "primaryContactPhone",
                            name: "primaryContactPhone",
                            placeholder: "Company Contact Phone Number",
                          },
                          domProps: { value: _vm.primaryContact.phone },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.primaryContact,
                                "phone",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _c("rbv-input-address-with-coordinates", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required: true}",
              },
            ],
            class: _vm.$style.addressForm,
            attrs: { name: "location", "form-opened": _vm.addressFormVisible },
            on: { formOpened: _vm.onFormOpened },
            model: {
              value: _vm.data.location,
              callback: function ($$v) {
                _vm.$set(_vm.data, "location", $$v)
              },
              expression: "data.location",
            },
          }),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c(
            "button",
            { staticClass: "rbButton mainButton" },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
              _vm.company.id
                ? [_vm._v(" Save ")]
                : [_vm._v(" Create New Company ")],
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }